import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/api';
import { Patrimonio } from 'src/app/admihair/api/dto/patrimonio';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PatrimonioService } from 'src/app/admihair/service/patrimonio.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-patrimonio-editar',
  templateUrl: './patrimonio-editar.component.html',
  styleUrls: ['./patrimonio-editar.component.scss']
})
export class PatrimonioEditarComponent implements OnInit {

  messages: Message[] = [];
  loading: boolean = false;
  permissaoEditar: boolean = false;
  progressoRequisicao: boolean = false;
  patrimonio?: Patrimonio;
  id?: number;

  constructor(
    private patrimonioService: PatrimonioService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService,
    private activatedRouter: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.permissaoEditar = AuthUtil.verificarPermissao('PERM_EDITAR_PATRIMONIO');
    this.obterId();
    if (this.permissaoEditar) {
      this.carregarPatrimonio();
    }
  }

  obterId() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) this.id = parseInt(idParam);
  }

  carregarPatrimonio() {

    this.patrimonioService.buscarPorId(this.id!).subscribe({
      next: (data: Patrimonio) => {
        this.patrimonio = data;
        this.patrimonio.dataAquisicaoAvaliacao = new Date((this.patrimonio.dataAquisicaoAvaliacao ?? '') + 'T05:00:00Z');
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
      }
    })
  }


  atualizar() {
    this.progressoRequisicao = true;
    this.patrimonioService.atualizar(this.id!, this.patrimonio!).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
      }
    })

  }

}
